import request from 'services/axios';

export const getThisYearCultivations = async () => {
  const {data}: {data: IThisYearCultivation[]} = await request.get(
    `/api/v2/farm/thisyear-cultivations`,
  );
  return data;
};
